import { render } from "./PopUpPreviewExerciseAdmin.vue?vue&type=template&id=0f7c3a90"
import script from "./PopUpPreviewExerciseAdmin.vue?vue&type=script&lang=js"
export * from "./PopUpPreviewExerciseAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__